export const segmentContinentOptions = [
    { name: 'Asia', value: 'AS' },
    { name: 'Africa', value: 'AF' },
    { name: 'Europe', value: 'EU' },
    { name: 'North America', value: 'NA' },
    { name: 'South America', value: 'SA' },
    { name: 'Oceania', value: 'OC' },
]
